import React, { useState }  from "react";
import { connect } from "react-redux";
import { Segment, Grid } from "semantic-ui-react";
import CarouselModal from '../../../../components/Responsive/Modal/CarouselModal';
import './CasesPage.css';

const TransitOutdoor = [
  require("../../../../images/cases/Transit & Outdoor/1_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/2_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/3_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/4_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/5_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/6_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/7_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/8_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/9_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/10_MTA - New York City.jpg"),
  require("../../../../images/cases/Transit & Outdoor/11_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/12_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/13_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/14_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/15_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/16_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/17_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/18_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/19_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/20_MBTA - Boston.jpg"),
  require("../../../../images/cases/Transit & Outdoor/21_WMATA - Washington, DC.jpg"),
  require("../../../../images/cases/Transit & Outdoor/22_WMATA - Washington, DC.jpg"),
  require("../../../../images/cases/Transit & Outdoor/23_WMATA - Washington, DC.jpg"),
  require("../../../../images/cases/Transit & Outdoor/24_CalTrain - San Francisco.jpg"),
  require("../../../../images/cases/Transit & Outdoor/25_CalTrain - San Francisco.jpg"),
  require("../../../../images/cases/Transit & Outdoor/26_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/27_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/28_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/29_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/30_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/31_VTA - Silicon Valley.jpg"),
  require("../../../../images/cases/Transit & Outdoor/32_VTA - Silicon Valley.jpg"),
];
const Indoor = [
  require("../../../../images/cases/Indoor/1_TSUTAYA - Kyushu.jpg"),
  require("../../../../images/cases/Indoor/2_TSUTAYA - Hokkaido.jpg"),
  require("../../../../images/cases/Indoor/3_Company Lobby - Tokyo.jpg"),
  require("../../../../images/cases/Indoor/4_HOTEL INDIGO HAKONE GORA - Japan.jpg"),
  require("../../../../images/cases/Indoor/5_Company lobby-LiFORK Lab - Japan.jpg"),
  require("../../../../images/cases/Indoor/6_Waiting lounge-Sanyukansahoujin - Japan.jpg"),
  require("../../../../images/cases/Indoor/7_Luxury apartment-Brillia Nerimatakanodai - Japan.jpg"),
  require("../../../../images/cases/Indoor/8_Sharyosuisen Japanese Cafe - Tokyo.jpg"),
  require("../../../../images/cases/Indoor/9_Puma golf - Okinawa.jpg"),
  require("../../../../images/cases/Indoor/11_Artistic video wall - New York City.jpg"),
  require("../../../../images/cases/Indoor/12_Rockefeller Center - New York City.jpg"),
];
const Event = [
  require("../../../../images/cases/Show Event/1_Dior Bellavita - Taipei.jpg"),
  require("../../../../images/cases/Show Event/2_Dior Bellavita - Taipei.jpg"),
  require("../../../../images/cases/Show Event/3_Dior Bellavita - Taipei.jpg"),
  require("../../../../images/cases/Show Event/4_Museum Tower Kyobashi - Tokyo.jpg"),
  require("../../../../images/cases/Show Event/5_Museum Tower Kyobashi - Tokyo.jpg"),
  require("../../../../images/cases/Show Event/6_The PIER-2 ART CENTER - Kaohsiung.jpg"),
  require("../../../../images/cases/Show Event/7_The PIER-2 ART CENTER - Kaohsiung.jpg"),
  require("../../../../images/cases/Show Event/8_The PIER-2 ART CENTER - Kaohsiung.jpg"),
];
const LED = [
  require("../../../../images/cases/LED/1_Odori Park - Sapporo.jpg"),
  // require("../../../../images/cases/LED/2_Company lobby - Sapporo.jpg"),
  require("../../../../images/cases/LED/3_Company lobby - Sapporo.jpg"),
];

const CasesPage = (props) => {
  const [open, setOpen] = useState(false);
  const [sliders, setSliders] = useState(TransitOutdoor);
  const { lang } = props;

  return (
    <div style={{ paddingTop: "36px", paddingBottom: "50px" }}>
      <CarouselModal open={open} onClose={() => setOpen(false)} sliderPictures={sliders} />
      <Segment basic vertical style={{ width: "90%", margin: "0 auto" }}>
        <Grid textAlign='center'>
          <Grid.Row only="computer" columns={1} style={{ margin: "60px auto 0", fontSize: '24px' }}>
            {lang.get("cases-header")}
          </Grid.Row>
          <Grid.Row only="tablet mobile" columns={1} style={{ margin: "20px auto 0", fontSize: '24px' }}>
            {lang.get("cases-header")}
          </Grid.Row>
        </Grid>
        <Grid textAlign='center'>
          <Grid.Row
            columns={1}
            style={{ margin: "0px 0px 60px", fontSize: '17px', lineHeight: '25px', padding: '0 16%' }}
            only="computer tablet"
          >
            {lang.get("cases-header-txt")}
          </Grid.Row>
          <Grid.Row
            columns={1}
            style={{ margin: "0px 0px 40px", fontSize: '15px', lineHeight: '25px', padding: '0 5%' }}
            only="mobile"
          >
            {lang.get("cases-header-txt")}
          </Grid.Row>
        </Grid>
        <Grid textAlign='center'>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className="__desktop_cases_grid_item"
              style={{
                backgroundImage: `url('${TransitOutdoor[0]}')`,
              }}
              onClick={() => { setOpen(true); setSliders(TransitOutdoor); }}
            >
              <div className="__desktop_cases_grid_item_mask" />
              <div className="__desktop_cases_grid_item_description">
                <h3>{lang.get("cases-item1-title")}</h3>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className="__desktop_cases_grid_item"
              style={{
                backgroundImage: `url('${Indoor[0]}')`,
              }}
              onClick={() => { setOpen(true); setSliders(Indoor); }}
            >
              <div className="__desktop_cases_grid_item_mask" />
              <div className="__desktop_cases_grid_item_description">
                <h3>{lang.get("cases-item2-title")}</h3>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className="__desktop_cases_grid_item"
              style={{
                backgroundImage: `url('${Event[0]}')`,
              }}
              onClick={() => { setOpen(true); setSliders(Event); }}
            >
              <div className="__desktop_cases_grid_item_mask" />
              <div className="__desktop_cases_grid_item_description">
                <h3>{lang.get("cases-item3-title")}</h3>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div
              className="__desktop_cases_grid_item"
              style={{
                backgroundImage: `url('${LED[0]}')`,
              }}
              onClick={() => { setOpen(true); setSliders(LED); }}
            >
              <div className="__desktop_cases_grid_item_mask" />
              <div className="__desktop_cases_grid_item_description">
                <h3>{lang.get("cases-item4-title")}</h3>
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </Segment>
    </div>
  );
}

const mapStateToProps = state => ({
  lang: state.langAction.languageTable
});

export default connect(mapStateToProps)(CasesPage);
